export enum ApplicationStatus {
  PENDING = 'PENDING',
  REJECTED_FOR_REVIEW = 'REJECTED_FOR_REVIEW',
  APPLICATION_FOR_RECONSIDERATION = 'APPLICATION_FOR_RECONSIDERATION',
  PERMISSION_TO_PAYMENT = 'PERMISSION_TO_PAYMENT',
  // REJECTED_DUE_TO_NON_IMPLEMENTATION = 'REJECTED_DUE_TO_NON_IMPLEMENTATION',
  PAYMENT_DONE = 'PAYMENT_DONE',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  // APPEAL_PENDING = 'APPEAL_PENDING',
  // APPEAL_CONFIRMED = 'APPEAL_CONFIRMED',
  // APPEAL_DECLINED = 'APPEAL_DECLINED',
  TEST_TAKERS = 'TEST_TAKERS',
  VERBAL_PASSERS = 'VERBAL_PASSERS',
  THOSE_WHO_FAILED_TEST = 'THOSE_WHO_FAILED_TEST',
  THOSE_WHO_DID_NOT_COME_TEST_TWICE = 'THOSE_WHO_DID_NOT_COME_TEST_TWICE',
  THOSE_WHO_DID_NOT_COME_VERBAL_TWICE = 'THOSE_WHO_DID_NOT_COME_VERBAL_TWICE',
}

export enum AppealStatus {
  PERMISSION_TO_PAYMENT = 'PERMISSION_TO_PAYMENT',
  PAYMENT_DONE = 'PAYMENT_DONE',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
}

export enum AttestationStatus {
  ABSENT = 'ABSENT',
  COMPLETED = 'COMPLETED',
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
}
export enum ApplicationStep {
  'zero' = '0',
  'one' = '1',
  'two' = '2',
  'three' = '3',
  'four' = '4',
}
